import { SalesIssue, SalesIssueFromJSON } from "./SalesIssue";


export interface SalesSummary {
    summary_name: string;
    qualification: number;
    analysis: number;
    estimation: number;
    proposal: number;
    negotiation: number;
    won: number;
    lost: number;
}

export function SalesSummaryFromJSON(json: any): SalesSummary {
    return {
        summary_name: json["summary_name"],
        qualification: json["qualification"],
        analysis: json["analysis"],
        estimation: json["estimation"],
        proposal: json["proposal"],
        negotiation: json["negotiation"],
        won: json["won"],
        lost: json["lost"],
    }
}


export interface SalesPipelineSummary {
    pipeline_summary_name: string;
    amount: number;
}

export function SalesPipelineSummaryFromJSON(json: any): SalesPipelineSummary {
    return {
        pipeline_summary_name: json["pipeline_summary_name"],
        amount: json["amount"],
    }
}


export interface SalesData {
    pipeline_summary: Array<SalesPipelineSummary>;
    summary: Array<SalesSummary>;
    sales_issues: Array<SalesIssue>;
}

export function SalesDataFromJSON(json: any): SalesData {
    return {
        pipeline_summary: (json["pipeline_summary"] as Array<any>).map(SalesPipelineSummaryFromJSON),
        summary: (json["summary"] as Array<any>).map(SalesSummaryFromJSON),
        sales_issues: (json["sales_issues"] as Array<any>).map(SalesIssueFromJSON),
    }
}
